import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
import Gitub from "@iconscout/react-unicons/icons/uil-github";

const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <div className="f-content">
        <div className="f-icons">
          <Insta color="white" size={"2rem"} />
          <Facebook color="white" size={"2rem"} />
          <Gitub color="white" size={"2rem"} />
        </div>
        <span color="#000">Email on tahasintonmoy87@gmail.com</span>
        <a href="https://web.facebook.com/alextonmoy2675">
        <span className="spg">Create By Tahasin Tonmoy</span>
        </a>
      </div>
    </div>
  );
};

export default Footer;
